import React from 'react'
import PropTypes from 'prop-types'
import { ScreenSwitch, Box, Modal as EPModal } from '@elparking/components'

const FilterContainer = ({ onClose, children }) => {
    return (
        <ScreenSwitch
          medium={() => (
              <Box w='100%' h='100%' overflow='hidden' background='white' p='1em'>
                  {children}
              </Box>
          )}
          other={() => (
              <EPModal
                isShown
                padding='0'
                position='absolute'
                label=''
                showCloseButton
                onClose={onClose}>
                  <Box h='auto' background='white' p='0 1em 1em 1em'>
                      {children}
                  </Box>
              </EPModal>
          )}
        />
    )
}

FilterContainer.propTypes = {
    onClose: PropTypes.func,
    children: PropTypes.node,
}

FilterContainer.defaultProps = {
    onClose: () => {},
}

export default FilterContainer
